import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { downloadExcel } from "react-export-table-to-excel";
import { TableHelpers } from "../../../../../helper/TableHelper";
import { requestStatus } from "../../../../../constants";

export const useDeleteAccountColumns = () => {
  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "150px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),

      //   render: (text: string) =>
      //     StringHelper.verticalBarSplit<string[]>(text)[1],
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => <div className="flag danger">Xóa</div>,
      width: "100px",
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      ...TableHelpers.searchInput({ dataIndex: "eDescription" }),
      onCell: () => {
        return {
          style: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "400px", // optional max width to constrain very long content
          },
        };
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "150px",
      render: (text: string, record: any = {}) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => status.includes(record.eRequestStatus),
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (_, record: any) => (
        <Button
          title="Xuất file"
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const header = ["Người sử dụng", "Mã nhân viên", "Bộ phận công tác", "Chi tiết đề nghị", "Lý do"];
            const body = JSON.parse(record.eContent);
            const mappedBody = body.map((record: any) => {
              const { id, ...bodyWithoutId } = record;
              return bodyWithoutId;
            });
            downloadExcel({
              fileName: "DS_TaiKhoan_Xoa_" + record.id,
              sheet: "Sheet1",
              tablePayload: {
                header,
                body: mappedBody,
              },
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
